import React from 'react';

function Home() {
  const quoteArray = [
    "Being deeply loved by someone gives you strength, while loving someone deeply gives you courage. - Lao Tzu",
    "Simplicity, patience, compassion. These three are your greatest treasures. Simple in actions and thoughts, you return to the source of being. Patient with both friends and enemies, you accord with the way things are. Compassionate toward yourself, you reconcile all beings in the world. - Lao Tzu",
    "The journey of a thousand miles begins with a single step. - Lao Tzu",
    "Knowing others is intelligence; knowing yourself is true wisdom. Mastering others is strength; mastering yourself is true power. - Lao Tzu",
    "Life is a series of natural and spontaneous changes. Don't resist them; that only creates sorrow. Let reality be reality. Let things flow naturally forward in whatever way they like. - Lao Tzu",
    "A good traveler has no fixed plans and is not intent on arriving. - Lao Tzu",
    "Those who know do not speak. Those who speak do not know. - Lao Tsu",
    "When you are content to be simply yourself and don't compare or compete, everyone will respect you. - Lao Tzu",
    "The truth is not always beautiful, nor beautiful words the truth. - Lao Tzu",
    "Time is a created thing. To say 'I don't have time,' is like saying, 'I don't want to.' - Lao Tzu",
    "The best fighter is never angry. - Lao Tzu",
    "If you are depressed you are living in the past. If you are anxious you are living in the future. If you are at peace you are living in the present. - Lao Tzu",
    "Because one believes in oneself, one doesn't try to convince others. Because one is content with oneself, one doesn't need others' approval. Because one accepts oneself, the whole world accepts him or her. - Lao Tzu",
    "A man with outward courage dares to die; a man with inner courage dares to live. - Lao Tzu",
    "Care about what other people think and you will always be their prisoner. - Lao Tzu",
    "Nature does not hurry, yet everything is accomplished. - Lao Tzu",
    "Be content with what you have; rejoice in the way things are. When you realize there is nothing lacking, the whole world belongs to you. - Lao Tzu",
    "At the center of your being you have the answer; you know who you are and you know what you want. - Lao Tzu",
    "Be careful what you water your dreams with. Water them with worry and fear and you will produce weeds that choke the life from your dream. Water them with optimism and solutions and you will cultivate success. Always be on the lookout for ways to turn a problem into an opportunity for success. Always be on the lookout for ways to nurture your dream. - Lao Tzu",
    "Do you have the patience to wait until your mud settles and the water is clear? - Lao Tzu",
    "Silence is a source of Great Strength. - Lao Tzu",
    "The flame that burns Twice as bright burns half as long. - Lao Tzu",
    "If you understand others you are smart. If you understand yourself you are illuminated. If you overcome others you are powerful. If you overcome yourself you have strength. If you know how to be satisfied you are rich. If you can act with vigor, you have a will. If you don't lose your objectives you can be long-lasting. If you die without loss, you are eternal. - Lao Tzu",
    "Stop thinking, and end your problems. - Lao Tzu",
    "Kindness in words creates confidence. Kindness in thinking creates profoundness. Kindness in giving creates love. - Lao-Tzu",
    "Manifest plainness, Embrace simplicity, Reduce selfishness, Have few desires. - Lao Tzu",
    "A leader is best When people barely know he exists Of a good leader, who talks little, When his work is done, his aim fulfilled, They will say, 'We did this ourselves.' - Lao Tzu",
    "Music in the soul can be heard by the universe. - Lao Tzu",
    "Act without expectation. - Lao Tzu",
    "Respond intelligently even to unintelligent treatment - Lao Tzu",
    "Appear weak when you are strong, and strong when you are weak. - Sun Tzu",
    "The supreme art of war is to subdue the enemy without fighting. - Sun Tzu",
    "If you know the enemy and know yourself, you need not fear the result of a hundred battles. If you know yourself but not the enemy, for every victory gained you will also suffer a defeat. If you know neither the enemy nor yourself, you will succumb in every battle. - Sun Tzu",
    "Let your plans be dark and impenetrable as night, and when you move, fall like a thunderbolt. - Sun Tzu",
    "In the midst of chaos, there is also opportunity - Sun-Tzu",
    "Supreme excellence consists of breaking the enemy's resistance without fighting. - Sun Tzu",
    "All warfare is based on deception. Hence, when we are able to attack, we must seem unable; when using our forces, we must appear inactive; when we are near, we must make the enemy believe we are far away; when far away, we must make him believe we are near. - Sun Tzu",
    "Victorious warriors win first and then go to war, while defeated warriors go to war first and then seek to win - Sun Tzu",
    "The greatest victory is that which requires no battle. - Sun Tzu",
    "If your enemy is secure at all points, be prepared for him. If he is in superior strength, evade him. If your opponent is temperamental, seek to irritate him. Pretend to be weak, that he may grow arrogant. If he is taking his ease, give him no rest. If his forces are united, separate them. If sovereign and subject are in accord, put division between them. Attack him where he is unprepared, appear where you are not expected. - Sun Tzu",
    "To know your Enemy, you must become your Enemy. - Sun Tzu",
    "There is no instance of a nation benefitting from prolonged warfare. - Sun Tzu",
    "Engage people with what they expect; it is what they are able to discern and confirms their projections. It settles them into predictable patterns of response, occupying their minds while you wait for the extraordinary moment — that which they cannot anticipate. - Sun Tzu",
    "Treat your men as you would your own beloved sons. And they will follow you into the deepest valley. - Sun Tzu",
    "Thus we may know that there are five essentials for victory: He will win who knows when to fight and when not to fight. He will win who knows how to handle both superior and inferior forces. He will win whose army is animated by the same spirit throughout all its ranks. He will win who, prepared himself, waits to take the enemy unprepared. He will win who has military capacity and is not interfered with by the sovereign. - Sun Tzu",
    "Even the finest sword plunged into salt water will eventually rust. - Sun Tzu",
    "Move swift as the Wind and closely-formed as the Wood. Attack like the Fire and be still as the Mountain. - Sun Tzu",
    "When you surround an army, leave an outlet free. Do not press a desperate foe too hard. - Sun Tzu",
    "Opportunities multiply as they are seized. - Sun Tzu",
    "Who wishes to fight must first count the cost - Sun Tzu",
    "There are not more than five musical notes, yet the combinations of these five give rise to more melodies than can ever be heard. There are not more than five primary colours, yet in combination they produce more hues than can ever been seen. There are not more than five cardinal tastes, yet combinations of them yield more flavours than can ever be tasted. - Sun Tzu",
    "When the enemy is relaxed, make them toil. When full, starve them. When settled, make them move. - Sun Tzu",
    "The art of war is of vital importance to the State. It is a matter of life and death, a road either to safety or to ruin. Hence it is a subject of inquiry which can on no account be neglected. - Sun Tzu",
    "If you wait by the river long enough, the bodies of your enemies will float by. - Sun Tzu",
    "Know yourself and you will win all battles - Sun Tzu",
    "To win one hundred victories in one hundred battles is not the acme of skill. To subdue the enemy without fighting is the acme of skill. - Sun Tzu",
    "So in war, the way is to avoid what is strong, and strike at what is weak. - Sun Tzu",
    "Be extremely subtle even to the point of formlessness. Be extremely mysterious even to the point of soundlessness. Thereby you can be the director of the opponent's fate. - Sun Tzu",
    "The wise warrior avoids the battle. - Sun Tzu",
    "Build your opponent a golden bridge to retreat across. - Sun Tzu"
  ];
  const getRandomQuote = (() => {
    let usedQuotes = new Set();
    
    return () => {
      // Reset used quotes if we've used them all
      if (usedQuotes.size >= quoteArray.length) {
        usedQuotes.clear();
      }
      
      // Keep trying until we get an unused quote
      let quote;
      do {
        const randomIndex = Math.floor(Math.random() * quoteArray.length);
        quote = quoteArray[randomIndex];
      } while (usedQuotes.has(quote));
      
      usedQuotes.add(quote);
      return quote;
    };
  })();

  const getRandomImage = (() => {
    let usedImages = new Set();
    
    return () => {
      const imageContext = require.context('../images/random', false, /\.(jpg|jpeg|png)$/i);
      const images = imageContext.keys();
      
      // Reset used images if we've used them all
      if (usedImages.size >= images.length) {
        usedImages.clear();
      }
      
      // Keep trying until we get an unused image
      let randomImage;
      do {
        const randomIndex = Math.floor(Math.random() * images.length);
        randomImage = imageContext(images[randomIndex]);
      } while (usedImages.has(randomImage));
      
      usedImages.add(randomImage);
      return randomImage;
    };
  })();

  return (
    <div className="container">
      <h1 className="title">
        <a href="/" style={{ textDecoration: 'none', color: 'inherit' }}>oustet</a>
      </h1>
      
      <div className="content-container">
        <div className="image-text-container">
          <img 
            src={getRandomImage()}
            alt="Black and white photograph"
            className="image"
          />
          <p className="quote">{getRandomQuote()}</p>
        </div>

        <div className="image-text-container">
          <p className="quote">{getRandomQuote()}</p>
          <img 
            src={getRandomImage()}
            alt="Black and white photograph"
            className="image"
          />
        </div>

        <div className="image-text-container">
          <img 
            src={getRandomImage()}
            alt="Black and white photograph"
            className="image"
          />
          <p className="quote">{getRandomQuote()}</p>
        </div>

        <div className="image-text-container">
          <p className="quote">{getRandomQuote()}</p>
          <img 
            src={getRandomImage()}
            alt="Black and white photograph"
            className="image"
          />
        </div>

        <div className="image-text-container">
          <img 
            src={getRandomImage()}
            alt="Black and white photograph"
            className="image"
          />
          <p className="quote">{getRandomQuote()}</p>
        </div>

        <div className="image-text-container">
          <p className="quote">{getRandomQuote()}</p>
          <img 
            src={getRandomImage()}
            alt="Black and white photograph"
            className="image"
          />
        </div>
      </div>
      
      <footer style={{ textAlign: 'center', marginTop: '2rem' }}>
        <a href="/about" style={{ textDecoration: 'none', color: 'inherit', fontSize: '0.9rem' }}>
          about
        </a>
      </footer>
    </div>
  );
}
export default Home; 